<template>
  <a-modal
    :closable="true"
    title=""
    centered
    width="960"
    :visible="visible"
    :mask-closable="false"
    :footer="null"
    @cancel="handleCancel"
  >
    <div class="learning-model-wrap">
      <a-spin v-if="spinning" style="margin-top: 40vh; width:960px" />
      <a-layout-content v-else :style="{ paddingTop: '10px', paddingRight: '20px', minHeight: '280px' }">
        <h5 v-if="timelineData.length > 0">
          {{ checkParams.practiceName }} | {{ checkParams.userName }}
        </h5>
        <Timeline
          :timeline-data="timelineData"
          :show-button="{
            checkButton: false,
            commentButton: true
          }"
          @handleGoCheck="handleGoCheck"
        />
      </a-layout-content>
    </div>
  </a-modal>
</template>

<script>
import Timeline from '@/components/timeline.vue'

export default {
  name: 'CheckModel',

  components: {
    Timeline
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    checkParams: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      timelineData: [],
      spinning: false
    }
  },

  watch: {
    visible: {
      handler(v) {
        if (v) {
          this.handleGetStudentSubmitData()
        }
      }
    }
  },

  methods: {
    handleGetStudentSubmitData() {
      this.timelineData = []
      const { classTypeId, lessonId, activeKey, userId } = this.checkParams
      const params = {
        classTypeId: +classTypeId,
        lessonId: +lessonId,
        linkType: +activeKey,
        userId: +userId,
        pageSize: 100,
        pageNum: 1,
        type: 2
      }
      this.spinning = true
      this.$service.correction.getStudentSubmitlist(params).then(result => {
        const { pathLogList } = result
        if (pathLogList) {
          this.timelineData = pathLogList.list
        } else {
          this.timelineData = []
        }
      }).finally(() => {
        this.spinning = false
      })
    },
    handleCancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped lang="less">
.learning-model-wrap {
    overflow: hidden;
    // 弹窗上下外边距40px
    height: calc(100vh - 80px - 60px);
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb{
      width: 6px;
      height: 6px;
      opacity: 0.8;
      border-radius: 3px;
      background: #C7C7C7;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-button {
      background: transparent;
    }
    &::-webkit-scrollbar-corner {
      background: transparent;
    }
    .ant-layout-content {
      width: 960px;
    }
  }
</style>
